import { Action, Module, MutationAction, VuexModule } from 'vuex-module-decorators'
import { RouteConfig } from 'vue-router'
import { getAllRoutes, resetRouter } from '@pazion/pazion-core/src/router'
import { DEFAULT_NAV_SORT_VALUE } from "@pazion/pazion-core/src/config";
import { IPermissionConfig } from '../models/permission-model';

const isShowInNav = (route: RouteConfig) => {
    if (!route.meta || !route.meta['show-in-nav']) {
        return false;
    }
    return true;
}

export const filterAsyncRoutes = (routes: RouteConfig[]): RouteConfig[] => {
    const res: RouteConfig[] = [];
    if (routes === null || routes === undefined || routes.length == 0) {
        return res;
    }

    routes.forEach(route => {
        const r = { ...route }
        if (isShowInNav(r)) {
            if (r.children) {
                r.children = filterAsyncRoutes(r.children);
            }
            res.push(r)
        }
    });
    res.sort((route1, route2) => {
        return route1.meta?.sort ?? DEFAULT_NAV_SORT_VALUE - route2.meta?.sort ?? DEFAULT_NAV_SORT_VALUE;
    });
    return res
}

const checkByRolePermissions = (routerItem: RouteConfig, rolePermissions: IPermissionConfig) => {
    return routerItem && 
    (routerItem.meta && routerItem.meta['show-in-nav'] &&
    rolePermissions.profileFlags[routerItem.meta.profilePermission])
    || routerItem.meta && !routerItem.meta.hasOwnProperty('profilePermission')
}

//NOTE: Filter routes by profile roles
const filterByProfilePermissions = (routes: RouteConfig[], rolePermissions: IPermissionConfig) => {
    return routes.filter(r => {
        if (r.hasOwnProperty('children')) {
            // @ts-ignore
            const childrenRoutes = r.children.filter(rch => {
                return rch && checkByRolePermissions(rch, rolePermissions)
           })           
            r.children = childrenRoutes;       
            return r && childrenRoutes.length > 0
        } else if (!r.hasOwnProperty('children'))  {
            return r && checkByRolePermissions(r, rolePermissions)
        }
    })
}

export interface IPermissionState {
    routes: RouteConfig[]
    routesWithPermission: RouteConfig[]
    rolePermissions: IPermissionConfig

}

//TODO: PERM
@Module({ name: 'permission' })
export default class Permission extends VuexModule implements IPermissionState {
    public routes: RouteConfig[] = [];
    public routesWithPermission: RouteConfig[] = [];
    public rolePermissions:IPermissionConfig = {} as IPermissionConfig


    @MutationAction({ mutate: ['routes'] })
    public async GenerateRoutes() {
        let routes: RouteConfig[] = filterAsyncRoutes(getAllRoutes());
        const sortRoutes = filterByProfilePermissions(routes, this.rolePermissions)
        return { routes: sortRoutes };
    }

    // TODO: PERM
    @MutationAction({ mutate: ['rolePermissions'] })
    public async setFeaturesFlagsMutation(config: { [key: string]: boolean }) {
        return { rolePermissions: config }
    }


    @Action
    async updateRoutes() {
        await this.GenerateRoutes();
    }

    //TODO: PERM Add correct types
    @Action
    async updatePermissons(config: { [key: string]: any }) {
        if (config)
            await this.setFeaturesFlagsMutation(config)
    }

    get getroutesWithPermissions() {
        return filterAsyncRoutes(this.routes);
    }

    get getFeatureFlags() {
        return this.rolePermissions?.featureFlags
    }
    get getHomeRoute(){
        return this.rolePermissions.base.homeRoute;
    }

    get getProfileFlags() {
        return this.rolePermissions?.profileFlags
    }
    get getConfig() {
        return this.rolePermissions?.config
    }

}//

